import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { COMPANY, IMAGES } from "@/lib/company";

const REASONS = [
  "Vehicle-focused transportation services",
  "Support for individuals and automotive businesses",
  "Long-distance transport coordination",
  "Vehicle purchasing and resale services",
  "Clear communication throughout the process",
];

export default function About() {
  return (
    <Layout>
      <div className="bg-slate-900" data-testid="about-header">
        <div className="mx-auto max-w-7xl px-4 py-12">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white">About Us</h1>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 py-14 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        <div>
          <p className="text-slate-700 leading-relaxed">
            {COMPANY.name} is a Florida-based automotive transportation and vehicle services company
            established in {COMPANY.established}.
          </p>
          <p className="mt-4 text-slate-700 leading-relaxed">
            We work with individuals, dealerships, wholesalers, and other businesses that need
            dependable vehicle transportation and automotive logistics services.
          </p>
          <p className="mt-4 text-slate-700 leading-relaxed">
            The company also participates in vehicle purchasing and resale activities and assists
            with transportation related to vehicle exports.
          </p>
        </div>
        <div className="rounded-md overflow-hidden border border-slate-200">
          <img src={IMAGES.towFlatbed} alt="Vehicle transport" className="w-full h-64 object-cover" />
        </div>
      </div>

      <div className="bg-slate-50 border-y border-slate-200">
        <div className="mx-auto max-w-5xl px-4 py-14">
          <h2 className="text-2xl font-bold text-slate-900">Why Choose Us</h2>
          <ul className="mt-6 space-y-3" data-testid="about-reasons">
            {REASONS.map((r) => (
              <li key={r} className="flex items-start gap-3 text-slate-700">
                <span className="mt-2 h-1.5 w-1.5 rounded-full bg-blue-800 shrink-0" />
                <span>{r}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 py-14">
        <div className="border border-slate-200 rounded-md p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <h3 className="text-lg font-bold text-slate-900">Work with us</h3>
            <p className="mt-1 text-slate-600">Request a transport quote or browse vehicles currently for sale.</p>
          </div>
          <div className="flex gap-3 shrink-0">
            <Link to="/contact?type=Transportation%20Quote" className="rounded-md bg-blue-800 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-900">Request a Quote</Link>
            <Link to="/catalog" className="rounded-md border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-800 hover:border-blue-700">View Catalog</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
